// src/components/MainHeader.js
import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import MenuDrawer from "./MenuDrawer";
import SearchOverlay from "./SearchOverlay";
import { useCart } from "../context/CartContext";
import { apiRequest } from "../services/api";
import { FiSearch } from "react-icons/fi";
import { HiOutlineShoppingBag } from "react-icons/hi2";

function MainHeader() {
  const { lang, toggleLanguage } = useContext(LanguageContext);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { cartItems, openDrawer } = useCart();
  const navigate = useNavigate();

  const cartCount = cartItems.reduce((sum, item) => sum + item.qty, 0);

  // 🔥 scroll detection
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div
  dir="ltr"
  className={`
    fixed left-0 w-full z-[9998]
    flex items-center justify-between
    px-4 transition-all duration-300
    bg-[#0F1A12]/90 backdrop-blur-md
    ${
      isScrolled
        ? "py-2 shadow-[0_0_20px_rgba(46,90,42,0.35)]"
        : "py-3 shadow-[0_2px_10px_rgba(0,0,0,0.2)]"
    }
  `}
  style={{
    top: isScrolled ? "0px" : "34px",
  }}
>
        {/* LEFT — MENU + SEARCH */}
        <div className="flex items-center gap-5">
          {/* MENU */}
          <button
            onClick={() => {
              setIsDrawerOpen(true);
              apiRequest("/analytics/track", {
                method: "POST",
                body: JSON.stringify({
                  action_type: "open_menu_header",
                  entity_type: "navigation",
                }),
              }).catch(() => {});
            }}
          >
            <div className="space-y-[3px] md:space-y-[4px]">
              {[...Array(4)].map((_, i) => (
                <span
                  key={i}
                  className="
                    block w-[18px] md:w-[22px]
                    h-[1px] md:h-[2px]
                    bg-[#9CB8A1] opacity-90
                  "
                />
              ))}
            </div>
          </button>

          {/* SEARCH */}
          <button
  onClick={() => setIsSearchOpen(true)}
  className="text-[#9CB8A1]"
>
            <FiSearch
  className="
    w-6 h-6 md:w-7 md:h-7
    text-[#9CB8A1]
    opacity-90 hover:opacity-100
    transition
  "
/>
          </button>
        </div>

        {/* CENTER — LOGO */}
        <button
          onClick={() => {
            apiRequest("/analytics/track", {
              method: "POST",
              body: JSON.stringify({
                action_type: "enter_home_from_header",
                entity_type: "navigation",
              }),
            }).catch(() => {});
            navigate("/");
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className={`
            flex items-center justify-center
            transition-transform duration-300
            ${isScrolled ? "scale-95" : "scale-105"}
          `}
        >
          <img
  src="/images/lions_logo_transparent.png"
  alt="Lions Logo"
  className="
  h-11 md:h-16
  max-w-[280px] md:max-w-[340px]
  object-contain
  opacity-100
  scale-105 md:scale-115
  drop-shadow-[0_0_14px_rgba(46,90,42,0.55)]
  transition-all duration-300
"
/>


        </button>

        {/* RIGHT — LANGUAGE + CART */}
        <div className="flex items-center gap-3">
          {/* LANGUAGE */}
          <button
  onClick={toggleLanguage}
  className="
    text-xs md:text-sm font-semibold
    px-3 py-1
    rounded-full
    border border-[#9CB8A1]
    text-[#9CB8A1]
    opacity-90 hover:opacity-100
    hover:bg-[#9CB8A1]/10
    transition
  "
>
  {lang === "EN" ? "EN" : "AR"}
</button>


          {/* CART */}
          <button
            id="main-cart-icon"
            onClick={() => {
              apiRequest("/analytics/track", {
                method: "POST",
                body: JSON.stringify({
                  action_type: "open_cart_from_header",
                  entity_type: "cart",
                }),
              }).catch(() => {});
              openDrawer();
            }}
            className="relative text-[#9CB8A1]"
          >
            <HiOutlineShoppingBag
  className="
    w-6 h-6 md:w-7 md:h-7
    text-[#9CB8A1]
    opacity-90 hover:opacity-100
    transition
  "
/>
            {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
          </button>
        </div>

        {/* LASER LINE */}
        <div className="absolute bottom-0 left-0 w-full h-[2px] hidden md:block overflow-hidden">
          <div className="h-full w-[80px] bg-[#2E5A2A]/80 animate-laserSlide"></div>
        </div>
      </div>

      {/* DRAWERS */}
      <MenuDrawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
      <SearchOverlay
        isOpen={isSearchOpen}
        onClose={() => setIsSearchOpen(false)}
      />
    </>
  );
}

export default MainHeader;
